import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { APP_ROUTES_CONFIG, ModuleType, Role } from '@contracts';
import { ModuleStore, normalizeRole, SessionStore } from '@core';

export type Access = {
  roles?: ReadonlyArray<Role>;
  modules?: ReadonlyArray<ModuleType>;
};

export const accessGuard: CanMatchFn = (route) => {
  const router = inject(Router);
  const moduleStore = inject(ModuleStore);
  const auth = inject(SessionStore);
  const config = inject(APP_ROUTES_CONFIG);

  const access = (route.data?.['access'] as Access | undefined) ?? undefined;

  const disabled = route.data?.['nav']?.disabled === true;

  if (disabled) {
    return router.parseUrl('/');
  }

  if (!access) return true;

  const module = moduleStore.module();
  const role = auth.getRole();
  if (!module) {
    return router.parseUrl('/');
  }
  const moduleOk = !access.modules?.length || access.modules.includes(module);

  const roleOk =
    !access.roles?.length ||
    access.roles.some(
      (role: string) => normalizeRole(role) === normalizeRole(role),
    );

  if (moduleOk && roleOk) {
    return true;
  }

  const fallbackRoute =
    config.defaultRoutes[module] ||
    config.defaultRoutes[config.defaultModule ?? ''] ||
    '/';

  return router.parseUrl(fallbackRoute);
};
